import { render, staticRenderFns } from "./ConnectWoocommerce.vue?vue&type=template&id=089f699d&lang=html"
import script from "./ConnectWoocommerce.vue?vue&type=script&lang=js"
export * from "./ConnectWoocommerce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports